import { render, staticRenderFns } from "./ContentDetails.vue?vue&type=template&id=19bd55d0&scoped=true&"
import script from "./ContentDetails.vue?vue&type=script&lang=js&"
export * from "./ContentDetails.vue?vue&type=script&lang=js&"
import style0 from "./ContentDetails.vue?vue&type=style&index=0&id=19bd55d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19bd55d0",
  null
  
)

export default component.exports